import { render, staticRenderFns } from "./PfsRichEditor.vue?vue&type=template&id=d4639e70&"
import script from "./PfsRichEditor.vue?vue&type=script&lang=js&"
export * from "./PfsRichEditor.vue?vue&type=script&lang=js&"
import style0 from "./PfsRichEditor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports